module.exports = __webpack_public_path__ + "img/footer-logo.750c39bc.png";